import React from 'react';
import Button from '../common/Button';

function RoleModal({ role, form, validationErrors, permissions, onClose, onSave, onChange }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  const handlePermissionToggle = (permId) => {
    const newPermissions = form.permissions.includes(permId)
      ? form.permissions.filter((p) => p !== permId)
      : [...form.permissions, permId];
    onChange({ ...form, permissions: newPermissions });
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" style={{ background: 'rgba(8,17,31,0.55)' }} onClick={onClose}>
      <div className="bg-white rounded-[12px] p-6 w-full max-w-[600px] max-h-[90vh] overflow-y-auto cs-content-scroll mx-4 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4 pb-4 border-b" style={{ borderColor: '#ddd6c6' }}>
          <h3 className="text-[18px] font-bold text-[#08111f]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {role ? 'Edit Role' : 'Create Role'}
          </h3>
          <button onClick={onClose} className="text-[20px] text-[#7a7060] hover:text-[#08111f]">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#7a7060] mb-1">Role Name (code) *</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => onChange({ ...form, name: e.target.value.toLowerCase().replace(/\s+/g, '_') })}
                className="w-full border-[1.5px] rounded-[9px] px-3 py-[9px] text-[12.5px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
                style={{ borderColor: '#ddd6c6' }}
                placeholder="custom_role"
                disabled={!!role}
                required
              />
            </div>
            <div>
              <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#7a7060] mb-1">Display Name *</label>
              <input
                type="text"
                value={form.displayName}
                onChange={(e) => onChange({ ...form, displayName: e.target.value })}
                className="w-full border-[1.5px] rounded-[9px] px-3 py-[9px] text-[12.5px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
                style={{ borderColor: '#ddd6c6' }}
                placeholder="Custom Role"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#7a7060] mb-1">Description</label>
            <textarea
              value={form.description}
              onChange={(e) => onChange({ ...form, description: e.target.value })}
              className="w-full border-[1.5px] rounded-[9px] px-3 py-[9px] text-[12.5px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#ddd6c6' }}
              placeholder="Role description"
              rows={2}
            />
          </div>

          <div>
            <label className="block text-[11px] font-semibold uppercase tracking-wider text-[#7a7060] mb-2">Permissions</label>
            <div className="border-[1.5px] rounded-[9px] p-3 max-h-[250px] overflow-y-auto cs-content-scroll" style={{ borderColor: '#ddd6c6', background: '#faf8f4' }}>
              <div className="grid grid-cols-2 gap-2">
                {permissions.map((perm) => (
                  <label key={perm._id} className="flex items-center gap-2 cursor-pointer py-1">
                    <input
                      type="checkbox"
                      checked={form.permissions.includes(perm._id)}
                      onChange={() => handlePermissionToggle(perm._id)}
                      className="rounded"
                    />
                    <span className="text-[12px] text-[#08111f]">
                      {perm.displayName || String(perm.name || '').replace(/_/g, ' ')}
                    </span>
                  </label>
                ))}
                {permissions.length === 0 && (
                  <div className="col-span-2 text-[12px] text-[#7a7060] py-2">No permissions available</div>
                )}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between pt-2 border-t" style={{ borderColor: '#e8e2d6' }}>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={form.isActive} onChange={(e) => onChange({ ...form, isActive: e.target.checked })} className="rounded" />
              <span className="text-[12.5px] text-[#08111f]">Active</span>
            </label>
            <div className="flex gap-3">
              <Button variant="ghost" onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="primary">
                {role ? 'Update' : 'Create'} Role
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RoleModal;
